import { render, staticRenderFns } from "./BusOthers.vue?vue&type=template&id=4ef668f0&scoped=true&"
import script from "./BusOthers.vue?vue&type=script&lang=js&"
export * from "./BusOthers.vue?vue&type=script&lang=js&"
import style0 from "./BusOthers.vue?vue&type=style&index=0&id=4ef668f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef668f0",
  null
  
)

export default component.exports